<template>
  <b-table
    :data="filteredPermissions.length ? filteredPermissions : []"
    :hoverable="true"
    :focusable="true"
    style="width: 100%"
  >
    <div class="is-flex px-3 pb-3">
      <b-field label="Username" label-position="on-border">
        <b-input
          placeholder="Input username to filter"
          v-model="filterText"
        ></b-input>
      </b-field>
    </div>
    <b-table-column
      field="username"
      label="Username"
      cell-class="has-text-left"
      v-slot="{ row: permission }"
    >
      <strong>
        {{ permission.id }}
      </strong>
    </b-table-column>

    <b-table-column
      field="createTournament"
      label="Create tournament"
      centered
      v-slot="{ row: permission }"
    >
      <b-checkbox v-model="permission.createTournament" />
    </b-table-column>

    <b-table-column
      field="hostSimul"
      label="Host simul"
      centered
      v-slot="{ row: permission }"
    >
      <b-checkbox v-model="permission.hostSimul" />
    </b-table-column>

    <b-table-column
      field="actions"
      cell-class="has-text-right"
      v-slot="{ row: permission }"
    >
      <b-button
        label="Update"
        type="is-primary"
        :loading="isLoading"
        @click="updatePermission(permission)"
      />
    </b-table-column>

    <template #empty>
      <div class="has-text-left">There is currently no permission</div>
    </template>
  </b-table>
</template>

<script>
import { firestore } from "@/services/firebase";

const permissions = firestore.collection("permissions");

export default {
  components: {},

  name: "PermissionTable",

  data() {
    return {
      isLoading: false,
      permissions: [],
      filterText: "",
    };
  },

  computed: {
    filteredPermissions() {
      if (!this.filterText) return this.permissions;
      const filtered = this.permissions.filter((p) => {
        return p.id.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1;
      });
      return filtered;
    },
  },

  methods: {
    async updatePermission(permission) {
      await permissions.doc(permission.id).update(permission);
      this.$buefy.toast.open({
        message: "Permission updated!",
        type: "is-success",
      });
    },
  },

  created() {
    this.$bind("permissions", permissions.where("admin", "==", false));
  },
};
</script>

<style scoped></style>
